module.exports = __webpack_public_path__ + "static/img/voiceBg.9f1b067a.png";